<template>
  <div>
    <header>
      <v-row>
        <v-col cols="12">
          <v-alert color="purple" dark dismissible outlined
            >Si cambia los filtros apriete el botón Calcular para re calcular
            las diferencias. Si elige una sede sin profesionales asociados, el
            botón Calcular estará deshabilitado.</v-alert
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="2" sm="4">
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="datesFormatted"
                label="Fecha desde / hasta"
                readonly
                v-on="on"
                prepend-icon="mdi-calendar"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dates" locale="es-ar" range></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="3" sm="4" class="filtro-sede">
          <v-select
            :items="sedes"
            item-text="nombre"
            item-value="idObraSocial"
            prepend-icon="mdi-calendar-multiple"
            v-model="sede"
            label="Sede"
            dense
            no-data-text="No hay Sedes configuradas"
            @change="buscarProfesionales"
          ></v-select>
        </v-col>
        <v-col cols="12" md="3" sm="4" class="filtro-sede">
          <v-select
            :items="profsBuscar"
            item-text="nombreProfesional"
            item-value="idProfesional"
            menu-props="auto"
            label="Profesional"
            hide-details
            prepend-icon="mdi-account"
            v-model="prof"
            no-data-text="No hay profesionales para la sede seleccionada"
            dense
          ></v-select>
        </v-col>
        <v-col class="reload-btn">
          <v-btn
            :disabled="!prof && prof !== 0"
            color="primary"
            @click="calcularTasas"
            >Calcular</v-btn
          >
        </v-col>
      </v-row>
    </header>
    <main>
      <v-row>
        <v-col cols="12" md="6" sm="4">
          <v-card>
            <v-card-title> Tasa de Uso </v-card-title>
            <v-data-table
              :headers="headersUso"
              :items="listaPacientesUso"
              group-by="sede"
              class="elevation-1 tabla-tasas"
              locale="es-ar"
              item-key="idPaciente"
              :items-per-page="10000"
              ref="myTable"
              :disable-sort="true"
              :hide-default-footer="true"
              no-data-text="Sin datos para los filtros seleccionados"
              :footer-props="{
                itemsPerPageText: 'Pacientes por página',
              }"
            >
            </v-data-table>
          </v-card>
        </v-col>
        <v-col cols="12" md="6" sm="4">
          <v-card>
            <v-card-title> Tasa de Adhesión </v-card-title>
            <v-data-table
              :headers="headersAdhesion"
              :items="listaPacientesAdhesion"
              group-by="sede"
              class="elevation-1 tabla-tasas"
              locale="es-ar"
              item-key="idPaciente"
              :items-per-page="10000"
              ref="myTable"
              :disable-sort="true"
              :hide-default-footer="true"
              no-data-text="Sin datos para los filtros seleccionados"
              :footer-props="{
                itemsPerPageText: 'Pacientes por página',
              }"
            >
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </main>
  </div>
</template>
<script>
import reportesMixin from "../../../mixins/reportesMixin";
import { getData } from "../../../api/apiService";
import moment from "moment";

export default {
  name: "PesoPaciente",
  mixins: [reportesMixin],
  data() {
    return {
      menu2: false,
      dates: [],
      sedes: [],
      sede: 0,
      datesFormatted: "",
      selected: null,
      headersUso: [
        {
          text: "Profesional",
          value: "nombreProfesional",
        },
        { text: "Sede", value: "sede" },
        { text: "Cant. Turnos Atendidos", value: "turnosAtendidos" },
        { text: "Cant. Turnos Reservados", value: "turnosTotales" },
        { text: "Tasa de Uso", value: "tasaUsoString" },
      ],
      headersAdhesion: [
        {
          text: "Profesional",
          value: "nombreProfesional",
        },
        { text: "Sede", value: "sede" },
        { text: "Cant. Pacientes Nuevos", value: "pacientesNuevos" },
        { text: "Cant. Pacientes Totales", value: "pacientesTotales" },
        { text: "Tasa de Adhesión", value: "tasaAdhesionString" },
      ],
      listaPacientesUso: [],
      listaPacientesAdhesion: [],
    };
  },
  watch: {
    dates(val) {
      if (val.length === 2) {
        moment.locale("fr");
        this.datesFormatted =
          moment(val[0]).format("L") + " - " + moment(val[1]).format("L");
        this.menu2 = false;
      }
    },
  },
  methods: {
    setInitialData() {
      const primerDiaMes = moment()
        .startOf("month")
        .format("YYYY-MM-DD");
      const diaActual = moment().format("YYYY-MM-DD");
      this.dates = [primerDiaMes, diaActual];
    },
    async calcularTasas() {
      this.$loading(true);
      const params = {
        idSede: this.sede,
        fechaDesde: this.dates[0],
        fechaHasta: this.dates[1],
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
        idProfesional: this.prof,
      };
      try {
        const pacientesData = await getData(
          "/Dashboard/CalcularTasaUso",
          params
        );
        this.listaPacientesUso = pacientesData;

        const adhesionData = await getData(
          "/Dashboard/CalcularTasaAdhesion",
          params
        );
        this.listaPacientesAdhesion = adhesionData;
      } catch (error) {
        console.log(error.message);
      } finally {
        this.$loading(false);
      }
    },
    buscarProfesionales() {
      if (this.sede === 0) {
        this.getProfesionales();
      } else {
        this.getProfesionalesSede(this.sede);
      }
    },
  },
  async created() {
    this.setInitialData();
    await this.getSedes();
    await this.getProfesionales();
    this.calcularTasas();
  },
};
</script>
<style scoped>
.tabla-tasas {
  max-height: 525px;
  overflow-y: auto;
}
::v-deep .tabla-tasas thead {
  background-color: #000 !important;
}
::v-deep .tabla-tasas thead th {
  color: #fff !important;
}
::v-deep .tabla-tasas .v-row-group__header {
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
}
::v-deep .tabla-tasas .v-row-group__header:hover {
  background-color: rgba(0, 0, 0, 0.65) !important;
}
::v-deep .tabla-tasas .v-row-group__header .v-btn--flat:last-child {
  visibility: hidden;
}
::v-deep .tabla-tasas .v-row-group__header td {
  text-transform: capitalize;
}
::v-deep .tabla-tasas .v-row-group__header td .v-icon::before {
  color: #fff;
  content: "\F0140" !important;
}
</style>
